
import { Alert, Button, Col, Descriptions, Form, Input, InputNumber, Modal, Row, Select, Space, Table, Tabs, Tag } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { DeleteOutlined, PlusOutlined, ExportOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';
import { ExportKPIPdf } from '../../Utils/exportKPIPdf';
import { useNavigate } from 'react-router';

function MyKpi() {
    const navigate = useNavigate();
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setdataModal] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();
    const [tasks, setTasks] = useState([]);
    const [kpiTask, setKpiTask] = useState([]);
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);

    // //Parameter
    const titlePage = 'Your KPI Data';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * page.pagination.pageSize + index },
        },
        {
            title: 'Title',
            dataIndex: 'title',
            key: "title",
            render: (text, record) => {
                return record.title
            }
        },
        // {
        //     title: 'Kode Karyawan',
        //     dataIndex: 'users_code',
        //     key: "users_code",
        //     render: (text, record) => {
        //         if (record.users !== null)
        //             return record.users.users_code
        //         else
        //             return "-";
        //     }
        // },
        // {
        //     title: 'Nama Karyawan',
        //     dataIndex: 'name',
        //     key: "name",
        //     render: (text, record) => {
        //         if (record.users !== null)
        //             return record.users.name
        //         else
        //             return "-";
        //     }
        // },
        {
            title: 'Division',
            dataIndex: 'division',
            key: "division",
            render: (text, record) => {
                if (record.division !== null)
                    return record.division.name
                else
                    return "-";
            }
        },
        {
            title: 'Max KPI Value',
            dataIndex: 'title',
            key: "title",
            render: (text, record) => {
                return record.kpi_value_max
            }
        },
        {
            title: 'Min KPI Value',
            dataIndex: 'title',
            key: "title",
            render: (text, record) => {
                return record.kpi_value_min
            }
        },
        {
            title: 'Created at',
            dataIndex: 'created_at',
            key: "created_at",
            render: (text, record) => {
                if (record.created_at !== "")
                    return (<p>{moment(record.created_at).format('DD-MM-YYYY HH:mm:ss')}</p>);
                else
                    return "-";
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    <>
                        <Button type="default" style={{ marginRight: 10 }} onClick={() => openModal('detail', record)}>
                            <b style={{ marginLeft: 5 }}>Detail</b>
                        </Button>
                        <Button type="primary" danger onClick={() => modalDeleteData(record)}>
                            <b style={{ marginLeft: 5 }}>Delete</b>
                        </Button>
                    </>
                );

            },
        },
    ];

    const dataColumns = [
        {
            title: "Type",
            dataIndex: "type",
            width: "5%",
            render: (id, record, index) => { ++index; return index },
        },
        {
            title: "Key Performance Areas / Indicators",
            dataIndex: "kpi_task_id",
            width: "65%",
            render: (_, record, index) => (
                <Form.Item
                    style={{ margin: 0, padding: 0 }}
                >
                    <Row gutter={8}>
                        <Col flex="auto" span={20}>
                            <Form.Item
                                name={[index, "kpi_task_id"]}
                                rules={[{ required: true, message: "Required" }]}
                                style={{ margin: 0 }}
                            >
                                <Select
                                    placeholder="Choose Jenis"
                                    onChange={(val) => handleTaskSelected(val, index)}
                                    style={{ width: '100%', maxWidth:600 }} // Ini akan menyesuaikan dgn lebar kolom
                                    optionLabelProp="label"
                                    dropdownStyle={{ maxWidth: 500 }} // Tambahan agar dropdown bisa lebar
                                >
                                    {kpiTask.map(e => (
                                        <Select.Option
                                            key={e.kpi_task_id}
                                            value={e.kpi_task_id}
                                            label={`${e.perfomance_area} - ${e.perfomance_indicators}`}
                                        >
                                            <div style={{
                                                whiteSpace: 'normal',
                                                wordBreak: 'break-word',
                                                padding: '6px 8px',
                                                lineHeight: '1.4',
                                            }}>
                                                <strong>{e.perfomance_area}</strong><br />
                                                <span>{e.perfomance_indicators}</span>
                                            </div>
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col>
                            <Button type='primary' onClick={() => navigate('/kpitask')}>+</Button>
                        </Col>
                    </Row>
                </Form.Item>
            ),
        },
        {
            title: "Weight",
            dataIndex: "weight",
            width: "10%",
            render: (_, record, index) => (
                <Form.Item name={[index, "weight"]} style={{ margin: 0 }}>
                    <InputNumber
                        style={{ width: "100%" }}
                        placeholder="Bobot"
                        disabled
                        readOnly
                    />
                </Form.Item>
            ),
        },
        {
            title: "Target",
            dataIndex: "target",
            width: "10%",
            render: (_, record, index) => (
                <Form.Item name={[index, "target"]} style={{ margin: 0 }}>
                    <InputNumber
                        style={{ width: "100%" }}
                        placeholder="Target"
                        disabled
                        readOnly
                    />
                </Form.Item>
            ),
        },
        {
            title: "Actual",
            dataIndex: "actual",
            width: "7%",
            render: (_, record, index) => (
                <Form.Item
                    name={[index, "actual"]}
                    rules={[{ required: true, message: "Required" }]}
                    style={{ margin: 0 }}
                >
                    <InputNumber onChange={(val) => handleTaskChange(val, index, 'actual')} style={{ width: 80 }} placeholder="Realisasi" />
                </Form.Item>
            ),
        },
        {
            title: "Score",
            dataIndex: "score",
            width: "5%",
            render: (_, record, index) => (
                <Form.Item
                    name={[index, "score"]}
                    rules={[{ required: true, message: "Required" }]}
                    style={{ margin: 0 }}
                >
                    <InputNumber disabled style={{ width: 60, WebkitAppearance: 'none' }} placeholder="Skor" readOnly />
                </Form.Item>
            ),
        },
        {
            title: "Final Score",
            dataIndex: "final_score",
            width: "5%",
            render: (_, record, index) => (
                <Form.Item
                    name={[index, "final_score"]}
                    rules={[{ required: true, message: "Required" }]}
                    style={{ margin: 0 }}
                >
                    <InputNumber
                        disabled
                        style={{ width: 90 }}
                        placeholder="Skor Akhir"
                        value={tasks[index]?.final_score || 0}
                        readOnly
                    />
                </Form.Item>
            ),
        },
        {
            title: "Action",
            width: "3%",
            render: (_, record, index) => (
                <Button type="link" danger onClick={() => removeTask(index)}>
                    <DeleteOutlined />
                </Button>
            ),
        },
    ];

    const taskColumns = [
        {
            title: "Type",
            dataIndex: "type",
            key: "type",
            render: (text, record) => {
                if (record.is_maximal === true)
                    return <Tag color='blue' >Maksimal</Tag>
                else
                    return <Tag color='cyan'>Minimal</Tag>
            }
        },
        {
            title: "Key Performance Areas",
            dataIndex: "perfomance_area",
            key: "perfomance_area",
            render: (text, record) => {
                return record.task.perfomance_area;
            }
        },
        {
            title: "Key Performance Indicators",
            dataIndex: "perfomance_indicators",
            key: "perfomance_indicators",
            render: (text, record) => {
                return record.task.perfomance_indicators;
            }
        },
        {
            title: "Weight",
            dataIndex: "weight",
            key: "weight",
            render: (text, record) => {
                return record.task.weight;
            }
        },
        {
            title: "Target",
            dataIndex: "target",
            key: "target",
            render: (text, record) => {
                return record.task.target;
            }
        },
        {
            title: "Actual",
            dataIndex: "actual",
            key: "actual",
        },
        {
            title: "Score",
            dataIndex: "score",
            key: "score",
        },
        {
            title: "Final Score",
            dataIndex: "final_score",
            key: "final_score",
        },
    ];


    useEffect(() => {
        getApi("GET", '/kpi?byuser=true&search=' + search + '&page=' + page.pagination.current, 'kpi');
        if (kpiTask.length === 0) {
            getApi("GET", '/kpitask?byuser=true&nopage=true', 'kpitask');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(page), isAlert]);

    const getApi = (method, url, type) => {
        setLoading(true);
        const dataReq = {
            method: method,
            url: url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                switch (type) {
                    case 'kpi':
                        setData(res.data.data);
                        setPage({
                            ...page,
                            pagination: {
                                ...page.pagination,
                                total: res.data.total_data
                            }
                        });
                        setLoading(false);
                        break;
                    case 'kpitask':
                        setKpiTask(res.data.data);
                        setLoading(false);
                        break;
                }
            } else {
                setLoading(false);
            }
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        })
    }

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method: method,
            url: url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setdataModal(null);
                setLoading(false);
                setIsAlert(true);
                setTextAlert(res.message);
                closeModal();
            } else {
                setLoading(false);
                modalError(res.message);
            }
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        })
    }

    const handleTaskSelected = (value, index) => {
        const task = kpiTask.find((e) => e.kpi_task_id === value);
        const updatedTasks = [...tasks];
        updatedTasks[index] = {
            ...updatedTasks[index],
            kpi_task_id: value,
            weight: task?.weight || 0,
            target: task?.target || 0,
        };
        setTasks(updatedTasks);
        form.setFieldsValue({ task: updatedTasks });
    };

    const modalDeleteData = (v) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Do you want to delete this data?',
            onOk: () => postApi('DELETE', '/kpiuser/' + v.kpi_id, null),
        });
    }

    const openModal = async (type, data) => {
        if (type === 'add') {
            setIsModal(true);
        } else if (type === 'detail') {
            setdataModal(data)
            setIsModalVisible(true);
        }
    }

    const onFinish = async (values) => {
        await postApi("POST", '/kpiuserv2', values);
    };

    const closeModal = () => {
        setdataModal(null);
        setIsModal(false);
        setTasks([]);
        form.resetFields();
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            ...sorter,
        });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    }

    const addTask = () => {
        const newTask = {
            kpi_task_id: null,
            weight: 0,
            target: 0,
            actual: null,
            score: null,
            final_score: null,
        };
        const updatedTasks = [...tasks, newTask];
        setTasks(updatedTasks);
        form.setFieldsValue({ task: updatedTasks });
    };

    const removeTask = (index) => {
        const updatedTasks = [...tasks];
        updatedTasks.splice(index, 1);
        setTasks(updatedTasks);
        form.setFieldsValue({ task: updatedTasks });
    };

    const handleTaskChange = (value, index, key) => {
        const updatedTasks = [...tasks];
        updatedTasks[index][key] = value;
        const task = updatedTasks[index];
        const kTask = kpiTask.find((e) => e.kpi_task_id === task.kpi_task_id);
        if (!kTask || !task.target) return;
        if (task.actual !== null && task.actual !== undefined && task.actual > 0) {
            task.score =
                kTask.is_maximal === true
                    ? parseFloat(((task.actual / task.target) * 100).toFixed(2))
                    : parseFloat(((task.target / task.actual) * 100).toFixed(2));
            task.final_score =
                kTask.is_maximal === true
                    ? parseFloat(((task.actual / task.target) * task.weight).toFixed(2))
                    : parseFloat(((task.target / task.actual) * task.weight).toFixed(2));
        }

        task.is_maximal = kTask.is_maximal
        setTasks(updatedTasks);
        form.setFieldsValue({ task: updatedTasks });

        const totalKpiMax = updatedTasks.reduce((sum, task) => {
            if (task.is_maximal === true) {
                return sum + parseFloat(task.final_score || 0);
            }
            return sum;
        }, 0);

        const totalKpiMin = updatedTasks.reduce((sum, task) => {
            if (task.is_maximal === false) {
                return sum + parseFloat(task.final_score || 0);
            }
            return sum;
        }, 0);

        const totalKpi = parseFloat((totalKpiMax + totalKpiMin).toFixed(2));
        form.setFieldsValue({
            kpi_value_max: totalKpiMax,
            kpi_value_min: totalKpiMin,
            kpi_value: totalKpi,
        });
    };

    const DetailModal = ({ isVisible, onClose, detailData }) => {
        return (
            <Modal
                title="KPI Details"
                open={isVisible}
                onCancel={onClose}
                footer={null}
                centered
                width={1000}
            >
                <Button onClick={() => ExportKPIPdf(detailData)} icon={<ExportOutlined />}>Export PDF</Button>
                <Tabs
                    items={[
                        {
                            key: "1",
                            label: "General Information",
                            children: (
                                <Descriptions column={1} size='small' bordered>
                                    <Descriptions.Item label="Title">
                                        {detailData?.title || "-"}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Description">
                                        {detailData?.desc || "-"}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Max KPI Value">
                                        {detailData?.kpi_value_max || "-"}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Min KPI Value">
                                        {detailData?.kpi_value_min || "-"}
                                    </Descriptions.Item>
                                </Descriptions>
                            ),
                        },
                        {
                            key: "2",
                            label: "Performance List",
                            children: (
                                <Table
                                    dataSource={detailData?.kpi_task || []}
                                    columns={taskColumns}
                                    pagination={false}
                                    rowKey={(record, index) => index}
                                    bordered
                                />
                            ),
                        },
                        {
                            key: "3",
                            label: "Additional Notes",
                            children: (
                                <p>
                                    {detailData?.notes
                                        ? detailData.notes
                                        : "No additional notes"}
                                </p>
                            ),
                        },
                    ]}
                />
            </Modal>
        );
    };

    return (
        <div style={{ padding: '20px' }}>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>

            {isAlert && (
                <Alert
                    message={textAlert}
                    type="success"
                    banner
                    closable
                    afterClose={() => setIsAlert(false)}
                    style={{ marginBottom: 16 }}
                />
            )}

            <h3 style={{ marginBottom: '20px', fontSize: '24px' }}>Your KPI </h3>

            <Row gutter={16} style={{ marginBottom: '20px' }}>
                <Col span={10}>
                    <Search
                        placeholder="Search"
                        allowClear
                        size="middle"
                        // onChange={(e) => setSearch(e.target.value)}
                        style={{ width: '100%' }}
                        onSearch={searchData}
                    />
                </Col>

                <Col span={14} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button type="primary" size="middle" onClick={() => openModal('add', null)}>
                        <PlusOutlined />
                        <b style={{ marginLeft: 5 }}>Add</b>
                    </Button>
                </Col>
            </Row>
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
                scroll={{ x: '100%' }}
                style={{ marginTop: '20px' }}
            />

            <Modal
                title="Your KPI Data"
                open={isModal}
                onOk={form.submit}
                onCancel={() => closeModal()}
                okText="Save"
                cancelText="Cancel"
                centered
                width={'90%'}
            >
                <Form
                    form={form}
                    name="kpiForm"
                    layout="vertical"
                    onFinish={onFinish}
                >

                    <Form.Item
                        name="title"
                        label="Title"
                        rules={[{ required: true, message: 'The title cannot be empty!' }]}
                    >
                        <Input placeholder="Enter Title" />
                    </Form.Item>

                    <Form.Item
                        name="desc"
                        label="Description"
                    >
                        <Input.TextArea placeholder="Enter Description" rows={4} />
                    </Form.Item>
                    <Form.Item
                        name="kpi_value"
                        label="Total KPI Value"
                        rules={[{ required: true, message: 'KPI Value cannot be empty!' }]}
                    >
                        <InputNumber disabled placeholder="0" readOnly style={{ width: "100%" }} />
                    </Form.Item>
                    <Row>
                        <Col span={11}>
                            <Form.Item
                                name="kpi_value_max"
                                label="Max KPI Value"
                                rules={[{ required: true, message: 'KPI Value cannot be empty!' }]}
                            >
                                <InputNumber disabled placeholder="0" readOnly style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                        <Col span={2} />
                        <Col span={11}>
                            <Form.Item
                                name="kpi_value_min"
                                label="Min KPI Value"
                                rules={[{ required: true, message: 'KPI Value cannot be empty!' }]}
                            >
                                <InputNumber disabled placeholder="0" readOnly style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.List label="Tasks" name="task">
                        {(fields, { add, remove }) => (
                            <>
                                <Table
                                    size="small"
                                    columns={dataColumns}

                                    dataSource={tasks}
                                    pagination={false}
                                    rowKey={(record, index) => index}
                                />
                                <Button type="primary" onClick={addTask} style={{ marginTop: 16 }}>
                                    Add Task
                                </Button>
                            </>
                        )}
                    </Form.List>
                </Form>
            </Modal>
            <DetailModal
                isVisible={isModalVisible}
                onClose={() => setIsModalVisible(false)}
                detailData={dataModal}
            />
        </div>
    );


}


export default MyKpi;